import coupon from "./coupon";
const subscribe = {
    confirmBtn: document.querySelector("#confirm_subscription"),
    init() {
        this.initPlanSelectionButtons();

        this.confirmBtn.addEventListener('click', function (e) {
            subscribe.confirmSubscription();
        });

        const acceptTerms = document.querySelector('#accept_terms');
        if (acceptTerms) {
            subscribe.confirmBtn.setAttribute('disabled', 'true');
            acceptTerms.addEventListener('change', function () {
                if (this.checked) {
                    subscribe.confirmBtn.removeAttribute('disabled');
                } else {
                    subscribe.confirmBtn.setAttribute('disabled', 'true');
                }
            });
        }

        subscribe.selectDefaultPlan();

    },
    async selectDefaultPlan(for_register = false) {
        // Auto-select default plan if none selected
        if (document.querySelector('[name="plan"]:checked') === null) {
            const defaultPlan = document.querySelector('[data-default-plan=true]');
            if (defaultPlan) {
                defaultPlan.click();
            }
        } else if (!for_register) {
            // Fetch prices for initially selected plan
            this.fetchPrices();
        }
    },
    async fetchPrices() {
        let checkedPlan = document.querySelector('[name="plan"]:checked');
        if (!checkedPlan) {
            return;
        }

        let coupon = document.querySelector("#subscribe_coupon_nr").value;

        let plan_id = checkedPlan.attributes.plan_id.value;
        let result = await API.post("/subscription/getPrice",{
            'plan_id': plan_id,
            'coupon': coupon
        });

        $("#summary_total_price1").text(result.total_formatted);
        $("#summary_total_price2").text(result.total_with_tax_formatted);

        let rows = `<tr><td>${result.plan_name}</td><td>1</td><td>${result.plan_price_formatted}</td><td>${result.plan_price_formatted}</td></tr>`;
        $("#period_label").text(result.period?.label || '');
        for (const limitation of (result.limitations || [])) {
            if (limitation.price > 0 && limitation.count > 0) {
                rows += `<tr><td>${language.extra} ${limitation.name.toLowerCase()}</td><td>${limitation.count} (${limitation.included} ${language.included})</td><td>${limitation.price_formatted}</td><td>${limitation.price_total_formatted}</td></tr>`;
            }
        }
        for (const app of (result.apps || [])) {
            if (app.tier_rows && app.tier_rows.length > 0) {
                for (const tier of app.tier_rows) {
                    rows += `<tr><td>${app.name}</td><td>${tier.count}x</td><td>${tier.price_formatted}</td><td>${tier.price_total_formatted}</td></tr>`;
                }
            } else if (app.price > 0 && app.count > 0) {
                rows += `<tr><td>${app.name}</td><td>${app.count}</td><td>${app.price_formatted}</td><td>${app.price_total_formatted}</td></tr>`;
            }
        }
        $("#summary_price_lines").html(rows);
        $("#renewal_date").text(result.period_renewal_date);
        if (result.chargeback_price > 0) {
            $("#plan_chargeback_cost_warning").html(language.chargeback_cost_warning_1 + result.chargeback_price_formatted + language.chargeback_cost_warning_2).show();
        } else {
            $("#plan_chargeback_cost_warning").text("").hide();
        }
        return;
    },
    async planAllowed(plan) {
        return new Promise(async function (resolve) {
            let result = await API.get("/subscription/planAllowed/" + plan);
            if (!result.status) {
                await modal.alert(result.title, null, result.msg);
            }
            resolve(result.status);
        });
    },
    initPlanSelectionButtons(for_registration = false) {
        const planButtons = document.querySelectorAll('.plan-select-btn');
        planButtons.forEach(button => {
            button.addEventListener('click', async function (e) {
                e.preventDefault();
                const planId = this.getAttribute('data-plan-id');
                const planName = this.getAttribute('data-plan-name');
                // Save previous selection before making changes
                const previouslyChecked = document.querySelector('[name="plan"]:checked');
                const previousPlanId = previouslyChecked ? previouslyChecked.getAttribute('plan_id') : null;

                // Check if plan is allowed
                const allowed = for_registration ? await subscribe.planAllowed(planId) : true;
                if (allowed) {
                    // Update radio button
                    const radioBtn = document.querySelector('.plan-radio-' + planId);
                    if (radioBtn) {
                        radioBtn.checked = true;
                    }
                    // Update all buttons
                    document.querySelectorAll('.plan-select-btn').forEach(btn => {
                        btn.classList.remove('btn-primary');
                        btn.classList.add('btn-light-primary');
                        btn.textContent = language.select;
                    });

                    document.querySelectorAll('.ribbon').forEach(btn => {
                        btn.style.display = 'none';
                    });

                    document.querySelector('.plan-ribbon-' + planId).style.display = 'block';

                    // Update all buttons with the same plan-id (both header and footer)
                    document.querySelectorAll('.plan-select-btn[data-plan-id="' + planId + '"]').forEach(btn => {
                        btn.classList.remove('btn-light-primary');
                        btn.classList.add('btn-primary');
                        btn.textContent = language.selected;
                    });

                    // Update column backgrounds
                    document.querySelectorAll('#pricing_table th, #pricing_table td').forEach(cell => {
                        cell.classList.remove('bg-light-primary');
                    });

                    const parentCell = this.closest('td') || this.closest('th');
                    const colIndex = parentCell ? Array.from(parentCell.parentElement.children).indexOf(parentCell) : -1;


                    if (colIndex >= 0) {
                        document.querySelectorAll(`#pricing_table tr`).forEach(row => {
                            const cell = row.children[colIndex];
                            if (cell && colIndex > 0) {
                                cell.classList.add('bg-light-primary');
                            }
                        });
                    }

                    if (!for_registration) {
                        // Fetch and update prices
                        await subscribe.fetchPrices();
                    }
                } else {
                    // Restore previous selection if plan not allowed
                    if (previousPlanId) {
                        const previousRadioBtn = document.querySelector('.plan-radio-' + previousPlanId);
                        if (previousRadioBtn) {
                            previousRadioBtn.checked = true;
                        }

                        // Restore button states
                        document.querySelectorAll('.plan-select-btn').forEach(btn => {
                            btn.classList.remove('btn-primary');
                            btn.classList.add('btn-light-primary');
                            btn.textContent = language.select;
                        });

                        document.querySelectorAll('.plan-select-btn[data-plan-id="' + previousPlanId + '"]').forEach(btn => {
                            btn.classList.remove('btn-light-primary');
                            btn.classList.add('btn-primary');
                            btn.textContent = language.selected;
                        });

                        // Restore ribbon
                        document.querySelectorAll('.ribbon').forEach(ribbon => {
                            ribbon.style.display = 'none';
                        });
                        document.querySelector('.plan-ribbon-' + previousPlanId).style.display = 'block';

                        // Restore column backgrounds
                        document.querySelectorAll('#pricing_table th, #pricing_table td').forEach(cell => {
                            cell.classList.remove('bg-light-primary');
                        });

                        // Find the column index for the previous plan
                        const previousButton = document.querySelector('.plan-select-btn[data-plan-id="' + previousPlanId + '"]');
                        if (previousButton) {
                            const previousParentCell = previousButton.closest('td') || previousButton.closest('th');
                            const previousColIndex = previousParentCell ? Array.from(previousParentCell.parentElement.children).indexOf(previousParentCell) : -1;

                            if (previousColIndex >= 0) {
                                document.querySelectorAll(`#pricing_table tr`).forEach(row => {
                                    const cell = row.children[previousColIndex];
                                    if (cell && previousColIndex > 0) {
                                        cell.classList.add('bg-light-primary');
                                    }
                                });
                            }
                        }
                    } else {
                        // Uncheck all if there was no previous selection
                        document.querySelectorAll('[name="plan"]').forEach(radio => {
                            radio.checked = false;
                        });

                        // Reset all buttons to unselected state
                        document.querySelectorAll('.plan-select-btn').forEach(btn => {
                            btn.classList.remove('btn-primary');
                            btn.classList.add('btn-light-primary');
                            btn.textContent = language.select;
                        });

                        // Hide all ribbons
                        document.querySelectorAll('.ribbon').forEach(ribbon => {
                            ribbon.style.display = 'none';
                        });

                        // Remove all column backgrounds
                        document.querySelectorAll('#pricing_table th, #pricing_table td').forEach(cell => {
                            cell.classList.remove('bg-light-primary');
                        });
                    }
                }
            });
        });
    },
    async confirmSubscription() {
        const checkedPlan = document.querySelector('[name="plan"]:checked');
        const planId = checkedPlan.attributes.plan_id.value;

        const allowed = await subscribe.planAllowed(planId);
        if (!allowed) {
            return;
        }

        subscribe.confirmBtn.setAttribute('data-kt-indicator', 'on');
        subscribe.confirmBtn.setAttribute('disabled', 'true');
        let result = await API.post("/subscription/confirmSubscription", {
            "plan_id": planId,
            "period": document.querySelector('[data-kt-plan="month"]').classList.contains('active') ? "month" : "year",
            "coupon": $("#subscribe_coupon_nr").val(),
        });
        if (result.status === 200) {
            if (result.action === 'redirect') {
                window.location.href = result.url;
            } else if (result.action === 'subscribed') {
                await modal.alert(language.planActivatedText);
                window.location.href = "/subscription";
            } else {
                await modal.alert(language.changePlanText);
                window.location.href = "/subscription";
            }
        } else {
            await modal.alert(language.default_error);
        }
        subscribe.confirmBtn.setAttribute('data-kt-indicator', 'off');
        subscribe.confirmBtn.removeAttribute('disabled');
    }
};
window.subscribe = subscribe;
export default subscribe;